<template>
  <div class="policy-inquiry-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <button class="back-btn" type="button" @click="goBack">
        <span class="back-icon">←</span>
        <span>返回</span>
      </button>
      <div class="page-header-text">
        <h1 class="page-title">我的保单</h1>
        <p class="page-subtitle">查看、管理您的保单与订单信息</p>
      </div>
    </div>

    <!-- Tab 切换 -->
    <div class="tab-bar">
      <div class="tab-item" :class="{ active: activeTab === 'policy' }" @click="switchTab('policy')">保单管理</div>
      <div class="tab-item" :class="{ active: activeTab === 'order' }" @click="switchTab('order')">订单管理</div>
    </div>

    <!-- 组件切换 -->
    <keep-alive>
      <component :is="activeTab === 'policy' ? 'PolicyList' : 'OrderManagement'" />
    </keep-alive>
  </div>
</template>

<script>
import PolicyList from './PolicyList.vue';
import OrderManagement from './OrderManagement.vue';

export default {
  name: 'PolicyInquiry',
  components: {
    PolicyList,
    OrderManagement
  },
  data() {
    return {
      activeTab: 'policy'
    };
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab;
    },
    goBack() {
      // 有历史则返回上一页，否则回首页
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push('/');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.policy-inquiry-page {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 30px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;

  > * {
    width: 100%;
    max-width: 1200px;
  }
}

// 页面标题
.page-header {
  margin-bottom: 24px;
  display: flex;
  align-items: baseline;
  gap: 16px;

  .page-header-text {
    flex: 1;
    display: flex;
    align-items: baseline;
    gap: 12px;
  }

  .page-title {
    font-size: 24px;
    font-weight: 600;
    color: #000;
    white-space: nowrap;
  }

  .page-subtitle {
    font-size: 16px;
    color: #666;
  }

  .back-btn {
    background: #ffffff;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 7px 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    color: #666;
    font-size: 14px;
    flex-shrink: 0;
    transition: all 0.2s;

    .back-icon {
      font-size: 16px;
      line-height: 1;
      font-weight: 600;
    }

    &:hover {
      color: #dd122a;
      border-color: #dd122a;
    }

    &:active {
      transform: scale(0.98);
    }
  }
}

// Tab 切换
.tab-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;

  .tab-item {
    padding: 8px 20px;
    font-size: 15px;
    color: #666;
    background: #fff;
    border-radius: 18px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      color: #dd122a;
    }

    &.active {
      color: #fff;
      background: #dd122a;
      font-weight: 500;
    }
  }
}
</style>
